import { render, staticRenderFns } from "./video-info.vue?vue&type=template&id=b64e2cbe&scoped=true&"
import script from "./video-info.vue?vue&type=script&lang=ts&"
export * from "./video-info.vue?vue&type=script&lang=ts&"
import style0 from "./video-info.vue?vue&type=style&index=0&id=b64e2cbe&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64e2cbe",
  null
  
)

export default component.exports